<template>
  <div>
    <TierContainer :defaultView="'tierListView'" />
  </div>
</template>

<script>
import TierContainer from '../components/tierContainer.vue';

export default {
  name: 'TierlistView',
  components: {
    TierContainer
  }
};
</script>